import React, { createContext, useContext, useState } from "react";

// The app shell renders a single primary view inside RootLayout. Today that is
// the chat; the Image Studio module adds a second view that replaces it without
// touching chat state. This context lets the Sidebar switch the active view and
// lets Home decide what to render.
export type AppView = "chat" | "studio";

interface ViewContextType {
  view: AppView;
  setView: (view: AppView) => void;
}

const ViewContext = createContext<ViewContextType | undefined>(undefined);

export const ViewProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [view, setView] = useState<AppView>("chat");
  return (
    <ViewContext.Provider value={{ view, setView }}>
      {children}
    </ViewContext.Provider>
  );
};

export const useView = () => {
  const context = useContext(ViewContext);
  if (!context) {
    throw new Error("useView must be used within a ViewProvider");
  }
  return context;
};
